import { AppPage } from '@juvare/common-web-ui/AppPage';
import { AppPageHeader1 } from '@juvare/common-web-ui/AppPageHeader1';
import { Link, Typography } from '@mui/material';
import { marked } from 'marked';
import React from 'react';
import { useNavigate } from 'react-router';
import { DocPageProps } from './DocPage';
import { Markdown } from './Markdown';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const html = marked(require('../../README.md').replace(/^#.*\n/g, '# Overview\n'));

export const Home: React.FC<{ pages: (DocPageProps & { path: string })[] }> = (props) => {
    const navigate = useNavigate();
    return (
        <AppPage header={<AppPageHeader1 title='Home' />} contentPadding={2} contentScrollable={true}>
            <Typography variant='h5'>Components</Typography>
            <Typography component='div'>
                <ul>
                    {props.pages.map((page) => (
                        <li key={page.path}>
                            <Link style={{ cursor: 'pointer' }} onClick={() => navigate(page.path)}>
                                {page.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Typography>
            <Markdown html={html} />
        </AppPage>
    );
};
